import React, { Component } from 'react';
import iconCard from '../images/iconCard.png';
import box_azul from '../images/box-azul.png';
import selos from '../images/selo3.png';
import axios from 'axios';
import Swal from 'sweetalert2';
import NumberFormat_ from 'react-number-format';
import { Redirect  } from 'react-router-dom';
import Image from './Image';

class payment extends Component {
    constructor(props){
        super(props);
        this.state = {
            showCredit: false,
            showDebt: false,
            showExistCard: false,
            cardList: [],
            cardSelect: "",
            CVV: "",
            showCVV: false,
            checkProgram: false,
            loading: "",
            cpfNumber: "",
            cardNumber: "",
            validadNumber: "",
            name: "",
            timeToRedirect: ""

        }
        this.getCards();
    }

    getCards = () => {
        axios.post(`https://www.pagtel.com.br/AlgarCasca360/v2/GetCard`, {
            transactionId: new Date().getTime(),
            msisdn: this.props.number
        }, { headers: {"Authorization": "Bearer " + this.props.token } })
        .then(res => {
            if((res.data.code == "P00")||(res.data.code == "P01")){
                if(res.data.cardList != null){
                    this.setState({cardList: res.data.cardList});
                    this.setState({showExistCard: true});
                }
                else {
                    this.setState({showCredit: true}); 
                }
            }
            else {
                Swal.fire({
                    title: 'Erro!',
                    text: res.data.msg,
                    type: 'error'
                });
            }

        })
        .catch(res => {
            Swal.fire({
            title: 'Erro!',
            text: "Erro ao carregar os cartões!",
            type: 'error'
            })
        })
    }

    selectPayment = (event) => {  
        if(event.target.value === "c"){
            this.setState({showCredit: true});
            this.setState({showDebt: false});
        }
        else {
            this.setState({showDebt: true});
            this.setState({showCredit: false});
        }
    }

    selctCard = (event) => {
        this.setState({cardSelect: event.target.value});
        this.setState({showCVV: true});
    }

    checkProgram = (event) => {
        this.setState({checkProgram: event.target.checked});
    }

    newCard = () => {
        this.setState({showExistCard: false});
        this.setState({showDebt: false});
        this.setState({showCredit: true});
    }

    buyRechard = () => {
        console.log(this.state.checkProgram);
        this.setState({loading: true}); 

        if(this.props.number == ""){
            Swal.fire({
                title: 'Erro!',
                text: "Escolha um telefone!",
                type: 'error'
            })
            this.setState({loading: false}); 
            return;
        }

        if((this.state.cardSelect == "")&&(this.state.showExistCard)){
            Swal.fire({
                title: 'Erro!',
                text: "Escolha o cartão!",
                type: 'error'
            })
            this.setState({loading: false}); 
            return;
        }

        if(this.props.choosePrice == 0){
            Swal.fire({
                title: 'Erro!',
                text: "Escolha o valor da recarga!",
                type: 'error'
            })
            this.setState({loading: false}); 
            return;
        }

        if(this.state.CVV == ""){
            Swal.fire({
                title: 'Erro!',
                text: "Digite o CVV!",
                type: 'error'
            })
            this.setState({loading: false}); 
            return;
        }

        if (this.state.showExistCard) {
            Swal.fire({
                title: 'Recarregar',
                text: "Você confirma a recarga no valor de R$" + (this.props.choosePrice)/100  + "?",
                showCancelButton: true,
                confirmButtonText: 'Sim'
              }).then((result) => {
                if (result.value) {
                    axios.post(`https://www.pagtel.com.br/AlgarCasca360/v2/recharge`, {
                        transactionId: new Date().getTime(),
                        msisdn: "55" + this.props.numberFixed.replace('55',''),
                        SMSISDN: "55" + this.props.number.replace('55',''),
                        paymentType: "C", 
                        paymentId: this.state.cardSelect,
                        Value: this.props.choosePrice,
                        cvv: this.state.CVV,
                        program: this.state.checkProgram
                    }, { headers: {"Authorization": "Bearer " + this.props.token } })
                    .then(res => {
                        if(res.data.code == "P00"){
                            Swal.fire({
                                title: 'Sucesso',
                                text: "Sua recarga foi realizada com sucesso. Em alguns minutos seus créditos estarão disponíveis!",
                                type: 'success'
                            })
                            this.setState({loading: false}); 
                            this.setState({timeToRedirect: false}); 
                        }
                        else {
                            Swal.fire({
                                title: 'Erro!',
                                text: res.data.msg,
                                type: 'error'
                            });
                            this.setState({loading: false});         
                        }
                    })
                    .catch(res => {
                        Swal.fire({
                            title: 'Erro!',
                            text: "Erro ao carregar os cartões!",
                            type: 'error'
                        })
                        this.setState({loading: false}); 
                    })
                }
                else {
                    this.setState({loading: false});         
                }
            })
        }
        else {
            axios.post(`https://www.pagtel.com.br/AlgarCasca360/v2/recharge`, {
                transactionId: new Date().getTime(),
                msisdn: "55" + this.props.numberFixed.replace('55',''),
                SMSISDN: "55" + this.props.number.replace('55',''),
                paymentType: "C", 
                paymentId: this.state.cardSelect,
                Value: this.props.choosePrice,
                cvv: this.state.CVV,
                program: this.state.checkProgram
            }, { headers: {"Authorization": "Bearer " + this.props.token } })
            .then(res => {
                if(res.data.code == "P00"){
                    Swal.fire({
                        title: 'Sucesso',
                        text: "Sua recarga foi realizada com sucesso. Em alguns minutos seus créditos estarão disponíveis!",
                        type: 'success'
                    })
                    this.setState({loading: false}); 
                    this.setState({timeToRedirect: true}); 
                }
                else {
                    Swal.fire({
                        title: 'Erro!',
                        text: res.data.msg,
                        type: 'error'
                    });
                    this.setState({loading: false});         
                }
            })
            .catch(res => {
                Swal.fire({
                    title: 'Erro!',
                    text: "Erro ao carregar os cartões!",
                    type: 'error'
                })
                this.setState({loading: false}); 
            })
        }
    }

    addCard = () => {
        console.log(this.state.checkProgram);

        this.setState({loading: true}); 

        if(this.props.number == ""){
            Swal.fire({
                title: 'Erro!',
                text: "Escolha um telefone!",
                type: 'error'
            })
            this.setState({loading: false}); 
            return;
        }

        if(this.state.name == ""){
            Swal.fire({
                title: 'Erro!',
                text: "Digite seu nome!",
                type: 'error'
            })
            this.setState({loading: false}); 
            return;
        }

        if(this.props.choosePrice == 0){
            Swal.fire({
                title: 'Erro!',
                text: "Escolha o valor da recarga!",
                type: 'error'
            })
            this.setState({loading: false}); 
            return;
        }



        if(this.state.cpfNumber === ""){
            Swal.fire({
                title: 'Erro!',
                text: "Digite o CPF!",
                type: 'error'
            })
            this.setState({loading: false}); 
            return;
        }

        if(this.state.cardNumber === ""){
            Swal.fire({
                title: 'Erro!',
                text: "Digite o número do cartão!",
                type: 'error'
            })
            this.setState({loading: false}); 
            return;
        }

        if(this.props.validadNumber === ""){
            Swal.fire({
                title: 'Erro!',
                text: "Digite a validade!",
                type: 'error'
            })
            this.setState({loading: false}); 
            return;
        }

        if(this.state.CVV === ""){
            Swal.fire({
                title: 'Erro!',
                text: "Digite o CVV!",
                type: 'error'
            })
            this.setState({loading: false}); 
            return;
        }
        Swal.fire({
            title: 'Recarregar',
            text: "Você confirma a recarga no valor de R$" + (this.props.choosePrice)/100 + "?",
            showCancelButton: true,
            confirmButtonText: 'Sim'
          }).then((result) => {
            if (result.value) {
                axios.post(`https://www.pagtel.com.br/AlgarCasca360/v2/addCard`, {
                    transactionID: new Date().getTime(),
                    paymentType:"C",
                    msisdn: "55" + this.props.numberFixed.replace('55',''),
                    cardNumber: this.state.cardNumber,
                    expiration: this.state.validadNumber,
                    cvv: this.state.CVV,
                    name:this.state.name,
                    cpf:this.state.cpfNumber,
                }, { headers: {"Authorization": "Bearer " + this.props.token } })
                .then(res => {
                    if(res.data.code == "P00"){
                        this.setState({cardSelect: res.data.paymentID});
                        this.buyRechard();
                    }
                    else {
                        Swal.fire({
                            title: 'Erro!',
                            text: res.data.msg,
                            type: 'error'
                        });
                        this.setState({loading: false});         
                    }
                })
                .catch(res => {
                    Swal.fire({
                        title: 'Erro!',
                        text: "Erro no cartão ao recarregar!",
                        type: 'error'
                    })
                    this.setState({loading: false}); 
                })
            }
            else {
                this.setState({loading: false});         
            }
        })
    }

    handleChange(event) {
        this.setState({name: event.target.value})
    }

    render() {
        const showCredit = this.state.showCredit ? 'active' : '';
        const showDebt = this.state.showDebt ? 'active' : '';
        const showExistCard = this.state.showExistCard ? 'active' : '';
        const showCVV = this.state.showCVV ? 'active' : '';
        const loading = this.state.loading ? 'Carregando...' : 'CONFIRMAR RECARGA';

        if(this.state.timeToRedirect){
            return <Redirect 
                to={{
                    pathname: "/MeusDados" ,
                    state:{
                        numberFormat: this.props.numberFormat,
                        number: this.props.number,
                        token: this.props.token
                    }
                }}
            />
        }

        return (
            <div className="content-recharge content-recharge--3">
                <img src={iconCard} className="icon-col"/>
                <h3>PAGAMENTO</h3>
                <div className="content-typecard--list">
                    <ul>
                        <li>
                            <input onChange={this.selectPayment} type="radio" id="number_credit" name="typeCard" value="c" defaultChecked={true}/>
                            <label for="number_credit">CARTÃO DE CRÉDITO</label>
                        </li>
                        {/* <li>
                            <input onChange={this.selectPayment} type="radio" id="number_debit" name="typeCard" value="d"/>
                            <label for="number_debit">CARTÃO DE DÉBITO</label>
                        </li> */}
                    </ul>
                </div>
                <div className={`content-info ${showCredit}`}>
                    <div className="input-info">
                        <label for="cpf">Nome:</label>
                        <input type="text" placeholder="Digite o nome" name="title" value={this.state.name}  onChange={this.handleChange.bind(this)}/>
                    </div>
                    <div className="input-info">
                        <label for="cpf">NÚMERO DO CPF</label>
                        <NumberFormat_  id="cpf" 
                                        name="cpf" 
                                        value={this.state.cpfNumber}  
                                        placeholder="Digite o número do CPF"
                                        onValueChange={(values) => {
                                            const {value} = values;
                                            this.setState({cpfNumber: value});
                                        }} 
                                        format="###.###.###-##" />
                    </div>
                    <div className="input-info">
                        <label for="number_card">NÚMERO DO CARTÃO</label>
                        <NumberFormat_  id="number_card" 
                            name="number_card" 
                            value={this.state.cardNumber}  
                            placeholder="Digite o número do cartão de crédito"
                            onValueChange={(values) => {
                                const {value} = values;
                                this.setState({cardNumber: value});
                            }} 
                            format="####.####.####.####" />
                    </div>
                    <div className="input-info--shell">
                        <div className="input-info">
                            <label for="validad">VALIDADE</label>
                            <NumberFormat_  id="validad" 
                                name="validad" 
                                value={this.state.validadNumber}  
                                placeholder="MM/AA"
                                onValueChange={(values) => {
                                    const {value} = values;
                                    this.setState({validadNumber: value});
                                }} 
                                format="##/##" />
                        </div>
                        <div className="input-info">
                            <label for="CVV">CVV</label>
                            <NumberFormat_  id="CVV" 
                                name="CVV" 
                                value={this.state.CVV}  
                                placeholder="CVV"
                                onValueChange={(values) => {
                                    const {value} = values;
                                    this.setState({CVV: value});
                                }} 
                                format="####" />
                        </div>
                    </div>
                    <div onClick={this.addCard}  className="btn-recharge">
                        {loading}
                    </div>
                    {/* <div className="active-recharge--program">
                        <input onChange={this.checkProgram} type="checkbox" id="program_0" value={this.state.checkProgram} name="program"/>
                        <label for="program_0">ATIVAR RECARGA PROGRAMADA</label>
                    </div>
                    <div className="active-recharge--program---info">
                        <img src={box_azul}/>
                    </div> */}
                    <div className="content-left-selos">
                        <img src={selos} alt="selos"/>
                    </div>
                </div>
                <div className={`content-info ${showDebt}`}>
                    <div className="input-info">
                        <label for="cpf">NÚMERO DO CPF</label>
                        <input type="text" id="cpf" name="cpf" value="" placeholder="Digite o número do CPF"/>
                    </div>
                    <div className="input-info">
                        <label for="number_card">NÚMERO DO CARTÃO <strong>(NÃO ACEITA ELO DÉBITO).</strong> </label>
                        <input type="text" id="number_card" name="number_card" value="" placeholder="Digite o número do cartão de crédito"/>
                    </div>
                    <div className="input-info--shell">
                        <div className="input-info">
                            <label for="validad">VALIDADE</label>
                            <input type="text" id="validad" name="validad" value="" placeholder="MM/AA"/>
                        </div>
                        <div className="input-info">
                            <label for="CVV">CVV</label>
                            <input type="text" id="CVV" name="CVV" value="" placeholder="CVV"/>
                        </div>
                    </div>
                    <div className="btn-recharge">
                        CONFIRMAR RECARGA
                    </div>
                    <div className="content-left-selos">
                        <img src={selos} alt="selos"/>
                    </div>
                </div>
                <div className={`content-info ${showExistCard}`}>
                    <ul className="listcard">
                        {this.state.cardList.map((item,i) => 
                            <li key={i}>
                                <input onChange={this.selctCard} type="radio" id={item.paymentID} value={item.paymentID} name="payment"/>
                                <label for={item.paymentID}>
                                    <Image type="internal" reactSRC={item.flag.toLowerCase()+".png"}/>
                                    <p>**** **** {item.digFour}</p>
                                </label>
                            </li>
                        )}
                    </ul>
                    <div className={`getCVV ${showCVV}`} >
                        <NumberFormat_ className="CVV" placeholder="CVV" 
                                        onValueChange={(values) => {
                                            const {value} = values;
                                            this.setState({CVV: value});
                                        }} 
                                        value={this.state.CVV} format="####" />
                        <div onClick={this.buyRechard} className="btn-recharge">
                            {loading}
                        </div>
                    </div>
                    <div onClick={this.newCard} className="btn-recharge">
                        NOVO CARTÂO
                    </div>
                    {/* <div className="active-recharge--program">
                        <input onChange={this.checkProgram} type="checkbox" id="program_1" value={this.state.checkProgram} name="program"/>
                        <label onClick={this.checkProgram} for="program_1">ATIVAR RECARGA PROGRAMADA</label>
                    </div>
                    <div className="active-recharge--program---info">
                        <img src={box_azul}/>
                    </div> */}
                    <div className="content-left-selos">
                        <img src={selos} alt="selos"/>
                    </div>
                </div>
            
            </div>    
        )
    }
}

export default payment; // Don’t forget to use export default!